import { FC } from 'react';

import { useGetWorkerList } from '@/modules/worker/hooks/useGetWorkerList';

interface IProps {
  readonly status?: string;
}

// Bug #13 — đếm theo Trạng thái chung (recruitment_status_id); trước đây gửi
// nhầm operational_status_id nên BE bỏ qua filter và mọi tab hiển thị tổng.
const CountListDataWorkerFilter: FC<IProps> = (props) => {
  const { data: workerList } = useGetWorkerList(
    props.status === undefined ? '' : `recruitment_status_id=${props.status}`
  );

  return <>({workerList?.total_rows})</>;
};

export { CountListDataWorkerFilter };
